import { render } from "./ModelIntro.vue?vue&type=template&id=1e5c1060"
import script from "./ModelIntro.vue?vue&type=script&lang=js"
export * from "./ModelIntro.vue?vue&type=script&lang=js"

import "./ModelIntro.vue?vue&type=style&index=0&id=1e5c1060&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__